import selectedConfig from "./selected-config.json";

type ProfileName = "local" | "test" | "production";

type SelectedConfig = {
  profile: ProfileName;
  apiBaseUrl: string;
  turnstileSiteKey: string;
  paypalClientId?: string;
};

const config = selectedConfig as SelectedConfig;

export const APP_PROFILE = config.profile;
export const APP_CONFIG = {
  apiBaseUrl: config.apiBaseUrl,
  turnstileSiteKey: config.turnstileSiteKey,
  paypalClientId: config.paypalClientId ?? ""
};
